'use client';

import Link from 'next/link';
import { useEffect, useState } from 'react';

import {
  TERMS_BANNER_END,
  TERMS_BANNER_START,
} from '../lib/marketing-constants';

export function TermsPrivacyBanner() {
  const now = new Date();
  const shouldShow = now >= TERMS_BANNER_START && now <= TERMS_BANNER_END;
  const [showLinks, setShowLinks] = useState(false);

  useEffect(() => {
    if (!shouldShow) {
      return;
    }

    const onScroll = () => {
      const banner = document.getElementById('termsPrivacyBanner');
      if (!banner) {
        return;
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      banner.style.transform = scrollTop > 0 ? 'translateY(-100%)' : 'translateY(0)';
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [shouldShow]);

  if (!shouldShow) {
    return null;
  }

  return (
    <div className="terms-privacy-banner" id="termsPrivacyBanner">
      <div className="banner-container">
        {!showLinks ? (
          <>
            <div className="banner-message">
              <span>We&apos;ve updated our </span>
              <strong>Terms &amp; Privacy Policy</strong>
              <span> to help recruiters discover your skills (never personal info).</span>
            </div>
            <div className="banner-actions">
              <button
                type="button"
                className="review-updates-btn"
                onClick={() => setShowLinks(true)}
              >
                Review Updates
              </button>
            </div>
          </>
        ) : (
          <div className="terms-privacy-links" style={{ display: 'flex' }}>
            <Link href="/terms-of-service" target="_blank" style={{ color: '#fff' }}>
              Terms of Service
            </Link>
            <span style={{ color: '#fff', margin: '0 4px' }}>|</span>
            <Link href="/privacy-policy" target="_blank" style={{ color: '#fff' }}>
              Privacy Policy
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
